<template>
  <div>
    <validation-observer ref="simpleRules">
      <b-card>
        <b-form @submit.prevent>
          <b-row>
            <b-col
              cols="12"
              lg="6"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="UserIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.generalInformation') }}
                  </h5>
                </div>

                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.prefix')"
                      label-for="mc-prefix"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Prefix"
                        rules="required"
                      >
                        <b-form-input
                          id="mc-prefix"
                          v-model="form.prefix"
                          :placeholder="$t('accountMembers.placeholders.enterPrefix')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.username')"
                      label-for="mc-username"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Username"
                        rules="required"
                      >
                        <b-form-input
                          id="mc-username"
                          v-model="form.username"
                          :placeholder="$t('accountMembers.placeholders.enterUsername')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.password')"
                      label-for="mc-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Password"
                        vid="Password"
                        rules="required|min:8|password"
                      >
                        <b-form-input
                          id="mc-password"
                          v-model="form.password"
                          type="password"
                          :placeholder="$t('accountMembers.placeholders.enterPassword')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.confirmPassword')"
                      label-for="mc-confirm-password"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Confirm Password"
                        rules="required|confirmed:Password"
                      >
                        <b-form-input
                          id="mc-confirm-password"
                          v-model="form.passwordConfirm"
                          type="password"
                          :placeholder="$t('accountMembers.placeholders.confirmPassword')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.nickname')"
                      label-for="mc-nickname"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Nickname"
                        rules="required"
                      >
                        <b-form-input
                          id="mc-nickname"
                          v-model="form.nickName"
                          :placeholder="$t('accountMembers.placeholders.enterNickname')"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('accountMembers.fields.phone')"
                      label-for="mc-phone"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Phone"
                        rules="required|digits:10"
                      >
                        <b-form-input
                          id="mc-phone"
                          v-model="form.phone"
                          :placeholder="$t('accountMembers.placeholders.phone')"
                          minlength="10"
                          maxlength="10"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="12"
                    md="6"
                  >
                    <b-form-group
                      :label="$t('Email')"
                      label-for="mc-email"
                      class="mb-0"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        rules="email"
                      >
                        <b-form-input
                          id="mc-email"
                          v-model="form.email"
                          :placeholder="$t('Email')"
                          type="email"
                          :state="errors.length > 0 ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col
              cols="12"
              lg="6"
              class="mb-2"
            >
              <b-card
                class="border h-100 mb-0 feature-card"
              >
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="SettingsIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.features') }}
                  </h5>
                </div>

                <b-row
                  class="feature-grid"
                  :class="{ 'feature-grid--single': visibleFeatureCount <= 1 }"
                >
                  <b-col
                    v-if="$can('update', 'agent')"
                    :cols="featureColumnCols"
                  >
                    <div class="feature-item">
                      <span class="feature-label">{{ $t('accountMembers.features.createAgent') }}</span>
                      <b-form-checkbox
                        v-model="form.canCreateAgent"
                        switch
                        class="ml-auto"
                      />
                    </div>
                  </b-col>

                  <b-col
                    v-if="$can('update', 'poy')"
                    :cols="featureColumnCols"
                  >
                    <div class="feature-item">
                      <span class="feature-label">{{ $t('accountMembers.features.webApi') }}</span>
                      <b-form-checkbox
                        v-model="form.canWebApi"
                        switch
                        class="ml-auto"
                      />
                    </div>
                  </b-col>

                  <b-col
                    v-if="$can('update', 'poy')"
                    :cols="featureColumnCols"
                  >
                    <div class="feature-item">
                      <span class="feature-label">{{ $t('accountMembers.features.sendPoy') }}</span>
                      <b-form-checkbox
                        v-model="form.canSendPoy"
                        switch
                        class="ml-auto"
                      />
                    </div>
                  </b-col>

                  <b-col
                    v-if="$can('update', 'payRate')"
                    :cols="featureColumnCols"
                  >
                    <div class="feature-item">
                      <span class="feature-label">{{ $t('accountMembers.features.customRate') }}</span>
                      <b-form-checkbox
                        v-model="form.canCustomPayRate"
                        switch
                        class="ml-auto"
                      />
                    </div>
                  </b-col>
                  <b-col
                    v-if="canManagePoyDetails"
                    :cols="featureColumnCols"
                  >
                    <div class="feature-item">
                      <span class="feature-label">{{ $t('accountMembers.features.poyDetailsCallback') }}</span>
                      <b-form-checkbox
                        v-model="form.canPoyDetailsCallback"
                        :aria-label="$t('accountMembers.features.poyDetailsCallback')"
                        switch
                        class="ml-auto"
                      />
                    </div>
                  </b-col>

                  <b-col
                    v-if="canManagePoyDetails"
                    :cols="featureColumnCols"
                  >
                    <div class="feature-item">
                      <span class="feature-label">{{ $t('accountMembers.features.poyDetailsApi') }}</span>
                      <b-form-checkbox
                        v-model="form.canPoyDetailsApi"
                        :aria-label="$t('accountMembers.features.poyDetailsApi')"
                        switch
                        class="ml-auto"
                      />
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>

            <b-col
              cols="12"
              lg="6"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0 position-relative">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="CreditCardIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.creditSetting') }}
                  </h5>
                </div>

                <div v-if="creditSetting.load">
                  <b-form-group
                    v-if="creditSetting.isMaster"
                    :label="$t('accountMembers.fields.walletType')"
                    label-for="wallet-type"
                  >
                    <div class="d-flex">
                      <b-form-radio
                        v-model="form.walletType"
                        class="custom-control-primary"
                        :value="0"
                      >
                        {{ $t('accountMembers.walletTypes.single') }}
                      </b-form-radio>
                      <b-form-radio
                        v-model="form.walletType"
                        class="custom-control-info ml-2"
                        :value="1"
                      >
                        {{ $t('accountMembers.walletTypes.transfer') }}
                      </b-form-radio>
                    </div>
                  </b-form-group>

                  <b-row v-if="form.walletType === 0">
                    <b-col
                      cols="12"
                      md="6"
                    >
                      <b-form-group
                        :label="$t('accountMembers.fields.ourPt')"
                        label-for="our-pt"
                      >
                        <b-form-input
                          id="mc-our-pt"
                          v-model="ourPercent"
                          :placeholder="$t('Our PT(%)')"
                          disabled
                        />
                      </b-form-group>
                    </b-col>

                    <b-col
                      cols="12"
                      md="6"
                    >
                      <b-form-group
                        :label="$t('accountMembers.fields.givenPt')"
                        label-for="mc-pt"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :name="$t('Given PT(%)')"
                          rules="required|decimal|min_value:1|max_value:100"
                        >
                          <b-form-input
                            id="mc-pt"
                            v-model="form.percent"
                            type="number"
                            :placeholder="$t('Given PT(%)')"
                            :state="errors.length > 0 ? false : null"
                            @input="finishInputPercent"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="form.walletType === 1">
                    <b-col
                      v-if="creditSetting.isMaster === false"
                      cols="12"
                      md="6"
                    >
                      <b-form-group
                        :label="$t('Your Credit')"
                        label-for="your-credit"
                      >
                        <b-form-input
                          id="your-credit"
                          v-model="creditSetting.credit"
                          type="number"
                          :placeholder="$t('Credit')"
                          readonly
                        />
                      </b-form-group>
                    </b-col>

                    <b-col
                      cols="12"
                      md="6"
                    >
                      <b-form-group
                        :label="$t('accountMembers.fields.credit')"
                        label-for="credit"
                      >
                        <validation-provider
                          v-if="creditSetting.isMaster"
                          #default="{ errors }"
                          name="Credit"
                          rules="decimal|min_value:0"
                        >
                          <b-form-input
                            id="credit"
                            v-model="form.credit"
                            type="number"
                            :placeholder="$t('accountMembers.placeholders.credit')"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <validation-provider
                          v-else
                          #default="{ errors }"
                          name="Credit"
                          :rules="`decimal|min_value:0|max_value:${creditSetting.credit}`"
                        >
                          <b-form-input
                            id="credit"
                            v-model="form.credit"
                            type="number"
                            :placeholder="$t('accountMembers.placeholders.credit')"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group
                    v-if="$can('update', 'poy') && form.canSendPoy"
                    :label="$t('accountMembers.fields.creditPoy')"
                    label-for="credit-poy"
                    class="mb-0"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Credit"
                      rules="decimal|min_value:1"
                    >
                      <b-form-input
                        id="credit-poy"
                        v-model="form.partnerCredit"
                        type="number"
                        :placeholder="$t('accountMembers.placeholders.enterCreditPoy')"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </div>

                <div
                  v-else
                  class="loading-center"
                >
                  <b-spinner
                    variant="primary"
                    small
                  />
                  <span class="ml-1">{{ $t('accountMembers.messages.loading') }}</span>
                </div>
              </b-card>
            </b-col>

            <b-col
              v-if="form.canWebApi"
              cols="12"
              lg="6"
              class="mb-2"
            >
              <b-card class="border h-100 mb-0">
                <div class="d-flex align-items-center mb-2">
                  <feather-icon
                    icon="GlobeIcon"
                    size="18"
                    class="mr-50 text-primary"
                  />
                  <h5 class="mb-0">
                    {{ $t('accountMembers.sections.apiSettings') }}
                  </h5>
                </div>

                <b-form-group
                  :label="$t('accountMembers.fields.websiteUrl')"
                  label-for="mc-website-url"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Website URL"
                    rules="url"
                  >
                    <b-form-input
                      id="mc-website-url"
                      v-model="form.websiteUrl"
                      :placeholder="$t('accountMembers.fields.websiteUrl')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  v-if="form.walletType === 0"
                  :label="$t('accountMembers.fields.callbackUrl')"
                  label-for="mc-callback-url"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="CallBack URL"
                    rules="url"
                  >
                    <b-form-input
                      id="mc-callback-url"
                      v-model="form.callbackUrl"
                      :placeholder="$t('accountMembers.fields.callbackUrl')"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  :label="$t('accountMembers.fields.ipWhitelist')"
                  label-for="ip-whitelist"
                  class="mb-0"
                >
                  <div
                    ref="whitelistForm"
                    class="ip-whitelist-inline"
                  >
                    <div
                      v-for="(v,i) in form.ipWhiteList"
                      :key="i"
                      ref="row"
                      class="ip-whitelist-tag"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="IP Whitelist"
                        rules="regex:^\d+\.\d+\.\d+\.\d+$"
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            v-model="form.ipWhiteList[i]"
                            :placeholder="$t('IP Address')"
                            :state="errors.length > 0 ? false : null"
                            style="width: 130px;"
                          />
                          <b-input-group-append>
                            <b-button
                              variant="outline-danger"
                              :disabled="form.ipWhiteList.length <= 1"
                              @click="removeItem(i)"
                            >
                              <feather-icon
                                icon="XIcon"
                                size="14"
                              />
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </div>
                    <b-button
                      v-ripple.400="'var(--hdg-ripple-primary)'"
                      variant="outline-primary"
                      size="sm"
                      class="ip-add-btn"
                      @click="addItem()"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        size="14"
                      />
                    </b-button>
                  </div>
                </b-form-group>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                size="lg"
                class="d-inline-flex align-items-center"
                @click.prevent="onSubmitForm"
              >
                <feather-icon
                  icon="UserPlusIcon"
                  size="18"
                  class="mr-50"
                />
                {{ $t('accountMembers.actions.submit') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BInputGroup,
  BInputGroupAppend,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { validatorDecimal } from '@core/utils/validations/validators'
import { heightTransition } from '@core/mixins/ui/transition'
import agentService from '@/service/agentService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BForm,
    BButton,
    BFormRadio,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      ourPercent: null,
      form: {
        prefix: '',
        username: '',
        password: '',
        passwordConfirm: '',
        nickName: '',
        phone: '',
        email: '',
        percent: '0',
        websiteUrl: '',
        callbackUrl: '',
        ipWhiteList: [''],
        canCreateAgent: true,
        canSendPoy: false,
        canWebApi: true,
        canCustomPayRate: false,
        canPoyDetailsCallback: false,
        canPoyDetailsApi: false,
        partnerCredit: 0,
        walletType: 0,
        credit: 0,
      },
      startPercent: 0,
      creditSetting: {
        load: false,
        isMaster: false,
        credit: 0,
        walletType: 0,
      },
    }
  },
  computed: {
    canManagePoyDetails() {
      return this.$store.getters['app/canManagePoyDetails']
    },
    visibleFeatureCount() {
      let count = 0
      if (this.$can('update', 'agent')) count += 1
      if (this.$can('update', 'poy')) count += 2
      if (this.$can('update', 'payRate')) count += 1
      if (this.canManagePoyDetails) count += 2
      return count
    },
    featureColumnCols() {
      return this.visibleFeatureCount <= 1 ? 12 : 6
    },
  },
  mounted() {
    agentService.getAuthen('percent').then(res => {
      if (res.status === 200) {
        this.creditSetting.load = true
        this.creditSetting.isMaster = res.data.isMaster
        this.creditSetting.credit = res.data.credit
        this.creditSetting.walletType = res.data.walletType
        if (this.creditSetting.isMaster === false) {
          this.form.walletType = res.data.walletType
        }
        this.percent = res.data.percent
        this.ourPercent = this.percent
        this.startPercent = this.percent
      }
    })
    this.initTrHeight()
  },
  methods: {
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.whitelistForm.scrollHeight)
      })
    },
    addItem() {
      this.form.ipWhiteList.push('')
      this.trAddHeight(this.$refs.row[0].offsetHeight)
    },
    removeItem(i) {
      if (this.form.ipWhiteList.length <= 1) return
      this.form.ipWhiteList.splice(i, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    finishInputPercent() {
      if (validatorDecimal(this.form.percent)) {
        const dt = this.startPercent - this.form.percent
        this.ourPercent = dt
      }
    },
    onSubmitForm() {
      this.$refs.simpleRules.validate()
        .then(async success => {
          if (success) {
            const formSender = { ...this.form }
            if (!this.canManagePoyDetails) {
              delete formSender.canPoyDetailsCallback
              delete formSender.canPoyDetailsApi
            }
            delete formSender.passwordConfirm
            if (formSender.websiteUrl.indexOf('https://') === -1) {
              formSender.websiteUrl = `https://${formSender.websiteUrl}`
            }
            if (formSender.callbackUrl.indexOf('https://') === -1) {
              formSender.callbackUrl = `https://${formSender.callbackUrl}`
            }
            formSender.credit = parseFloat(formSender.credit)
            // eslint-disable-next-line no-unreachable
            const res = await agentService.postAuthen('', formSender)
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('success'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: res.data,
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('Error'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
    },
  },
}
</script>

<style lang="scss">

.repeater-form {
  overflow: hidden;
  transition: .35s height !important;
}

.inline-spacing {
  display: flex;
  flex-wrap: wrap;
  text-align: end;
  justify-content: flex-start;
  align-items: center;

  & > * {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    //margin-left: 1.5rem;
  }
}

.loading-center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  color: var(--secondary);
}

.feature-card {
  .card-body {
    display: flex;
    flex-direction: column;
  }
}

.feature-grid {
  flex: 0 0 auto;
}

.feature-grid--single {
  margin-top: 0.25rem;
}

.feature-item {
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 0.5rem 0;
}

.feature-grid--single .feature-item {
  width: 100%;
  min-height: 3.5rem;
  padding: 0.5rem 0;
  border-top: 1px solid rgba(130, 134, 154, 0.12);
  border-bottom: 1px solid rgba(130, 134, 154, 0.12);
}

.feature-label {
  color: var(--body-color);
  font-weight: 500;
}

.feature-grid--single .feature-label {
  font-size: 1rem;
}

.dark-layout {
  .feature-grid--single .feature-item {
    border-top-color: rgba(217, 220, 229, 0.09);
    border-bottom-color: rgba(217, 220, 229, 0.09);
  }
}

.ip-whitelist-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: flex-start;

  .ip-whitelist-tag {
    min-width: 175px;
  }

  .ip-add-btn {
    min-width: 38px;
  }
}

</style>
